import { Menu, MenuButton, Button, MenuList, MenuItem } from '@chakra-ui/react';

import { Role } from '../../../models';
import { ReactComponent as ChevronDownIcon } from '../../../assets/icons/chevron-down.svg';
import { useState } from 'react';

export const RolesMenu = ({
  roles,
  onChangeMenuItem,
}: {
  roles: Role[];
  onChangeMenuItem: (roleId: number) => void;
}) => {
  const [roleName, setRoleName] = useState('Move to another role');

  return (
    <Menu>
      <MenuButton
        as={Button}
        rightIcon={<ChevronDownIcon />}
        fontSize="xs"
        color="custom_gray.1"
        bg="transparent"
        _hover={{ bg: 'transparent' }}
      >
        {roleName}
      </MenuButton>
      <MenuList>
        {roles.map(({ name, id: roleId }) => (
          <MenuItem
            key={roleId}
            fontSize="sm"
            color="custom_blue.1"
            onClick={() => {
              onChangeMenuItem(roleId);
              setRoleName(name);
            }}
          >
            {name}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};
